import { tw } from "@careinfo/tailwind";

const LoadingSkeleton = ({ count = 1 }) => (
  <div className={tw`h-8 animate-pulse bg-gray-200`} />
);

const TableHeader = () => (
  <div
    className={tw`h-10 bg-primary flex items-center gap-x-1 justify-between text-white uppercase animate-pulse`}
  >
    {Array.from({ length: 7 }).map((_, index) => (
      <div key={index} className={tw`h-10 w-full rounded-xl animate-pulse`} />
    ))}
  </div>
);

export default function Template({ addNewPath, limit = 10 }) {
  return (
    <div className={tw`w-full bg-white rounded-sm mb-8 shadow-md`}>
      {addNewPath && (
        <button
          className={tw`bg-gray-200 h-10 w-32 my-2 rounded animate-pulse`}
        />
      )}
      <TableHeader />
      <div className={tw`flex flex-col gap-y-1 mt-1`}>
        {Array.from({ length: limit }).map((_, index) => (
          <LoadingSkeleton key={index} />
        ))}
      </div>
    </div>
  );
}
